export const schema: any = {
    cctv: [
        {
            "field": "v-upload-id",
            "label": "Upload ID",
            "vvalidate": "required"
        },
        {
            "field": "v-select",
            "label": "Inspection Purpose",
            "vvalidate": "required",
            "items": [
                "Planned Project",
                "CapEx As-Built",
                "Subdivision Compliance",
                "Operations & Maintenance",
                "Other"
            ]
        },
        {
            "field": "v-client-contact",
            "label": "Client Contact",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Project Name",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Project Reference",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Expected Project Meters (m)",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Upload Meters (m)",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Description & Comments",
            "vvalidate": "required"
        }
    ],
    miscellaneous: [
        {
            "field": "v-upload-id",
            "label": "Upload ID",
            "vvalidate": "required"
        },
        {
            "field": "v-client-contact",
            "label": "Client Contact",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Project Name",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Project Reference",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Expected Project Meters (m)",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Upload Meters (m)",
            "vvalidate": "required"
        },
        {
            "field": "v-text-field",
            "label": "Description & Comments",
            "vvalidate": "required"
        }
    ]
}
